/* @flow */
import getApiHost from './apiHost';
import {
    callFetch,
    API_GET,
    API_DELETE,
    API_POST,
    API_PUT
} from './apiBase';

export function submitTaskApi(jwtToken:string,payload:any|null){
    let url=`${getApiHost()}/api/worker/tasks/submit`;
    return callFetch(API_POST,url,payload,jwtToken);
}

export const getVendorsListApi=()=>{
    let url=`${getApiHost()}/api/vdpVendors`;
    return callFetch(API_GET,url)
}

export const getProjApolloAcctNos=(jwt:string,vendorCode:string)=>{
    let url=`${getApiHost()}/api/projApollo/acctNos/${vendorCode}`;
    return callFetch(API_GET,url,null,jwt);
}

export const getProjApolloCustNames=(jwt:string,vendorCode:string,acctNo:string)=>{
    let url=`${getApiHost()}/api/projApollo/custNames?vendorCode=${vendorCode}`;
    if (acctNo){
        url+=`&acctNo=${acctNo}`
    }
    return callFetch(API_GET,url,null,jwt);
}

export const getProjApolloChargeDescs=(jwt:string,vendorCode:string,acctNo:string)=>{
    let url=`${getApiHost()}/api/projApollo/chargeDescs?vendorCode=${vendorCode}`;
    if (acctNo){
        url+=`&acctNo=${acctNo}`
    }
    return callFetch(API_GET,url,null,jwt);
}

export const getProjApolloServiceAddresses=(jwt:string,vendorCode:string,acctNo:string)=>{
    let url=`${getApiHost()}/api/projApollo/serviceAddresses?vendorCode=${vendorCode}`;
    if (acctNo){
        url+=`&acctNo=${acctNo}`
    }
    return callFetch(API_GET,url,null,jwt);
}

export const postValidatVendorNAcctNoApi=(jwtToken:string,payload:any|null)=>{
    let url=`${getApiHost()}/api/projApollo/validateAcctNo`;
    return callFetch(API_POST,url,payload,jwtToken);
}

export const getImgBboxDataUrlApi=(taskId:string)=>{
    let url=`${getApiHost()}/api/imgBboxDataUrl/${taskId}`;
    return callFetch(API_GET,url,null);
}

export const getDemeterVendorsApi=(jwt:string,compIdCode:string)=>{
    let url=`${getApiHost()}/api/demeter/vendors/${compIdCode}`;
    return callFetch(API_GET,url,null,jwt);
}

export const getDemeterStoreLocationsApi=(jwt:string,compIdCode:string)=>{
    let url=`${getApiHost()}/api/demeter/storeLocations/${compIdCode}`;
    return callFetch(API_GET,url,null,jwt);
}

export const getApolloItemsApi=(jwtToken:string,page:string,pageSize:string,sortField:string,sortOrder:string,taskAcceptedInfoId:string)=>{
    const apiUrl = `${getApiHost()}/api/worker/task/apollo/items/${taskAcceptedInfoId}`;
    let url=`${apiUrl}?page=${page}&pageSize=${pageSize}`;

    if (sortField && sortOrder) { 
        url+=`&sortField=${sortField}&sortOrder=${sortOrder}`
    };
    
    return callFetch(API_GET,url,null,jwtToken);
}

export const createApolloItemApi=(jwtToken:string,payload:string,taskAcceptedInfoId:string)=>{
    const apiUrl = `${getApiHost()}/api/worker/task/apollo/items/${taskAcceptedInfoId}`;
    return callFetch(API_POST,apiUrl,payload,jwtToken);
}

export const updateApolloItemApi=(jwtToken:string,payload:string,id:string)=>{
    const apiUrl = `${getApiHost()}/api/worker/task/apollo/item/${id}/update`;
    return callFetch(API_PUT,apiUrl,payload,jwtToken);
}

export const moveDownApolloItemApi=(jwtToken:string,id:string)=>{
    const apiUrl = `${getApiHost()}/api/worker/task/apollo/item/${id}/moveDown`;
    return callFetch(API_PUT,apiUrl,{},jwtToken);
}

export const moveUpApolloItemApi=(jwtToken:string,id:string)=>{
    const apiUrl = `${getApiHost()}/api/worker/task/apollo/item/${id}/moveUp`;
    return callFetch(API_PUT,apiUrl,{},jwtToken);
}

export const deleteApolloItemApi=(jwtToken:string,id:string)=>{
    const apiUrl = `${getApiHost()}/api/worker/task/apollo/item/${id}/delete`;
    return callFetch(API_DELETE,apiUrl,{},jwtToken);
}

export const getTaskConfigApi=(jwtToken:string,taskAcceptId:string)=>{
    const apiUrl = `${getApiHost()}/api/worker/task/conf/${taskAcceptId}`;
    return callFetch(API_GET,apiUrl,{},jwtToken);
}

export const getImgSegmentQuestionApi=(jwtToken:string,taskAcceptKey:string)=>{
    const apiUrl = `${getApiHost()}/api/imgSegment/question/${taskAcceptKey}`;
    return callFetch(API_GET,apiUrl,{},jwtToken);
}

export const getNextImgSegmentDatasetApi=(jwtToken:string,imgSegmentQuestionId:string)=>{
    const apiUrl = `${getApiHost()}/api/imgSegment/nextDataset/${imgSegmentQuestionId}`;
    return callFetch(API_GET,apiUrl,{},jwtToken);
}

export const getImgSegmentDatasetsApi=(jwtToken:string,page:string,pageSize:string,sortField:string,sortOrder:string,imgSegmentQuestionId:string)=>{
    const apiUrl = `${getApiHost()}/api/imgSegment/datasets/completed/results/${imgSegmentQuestionId}`;
    let url=`${apiUrl}?page=${page}&pageSize=${pageSize}`;

    if (sortField && sortOrder) { 
        url+=`&sortField=${sortField}&sortOrder=${sortOrder}`
    };
    
    return callFetch(API_GET,url,null,jwtToken);
}

export const getDemeterItemsApi=(jwtToken:string,page:string,pageSize:string,sortField:string,sortOrder:string,taskAcceptedInfoId:string)=>{
    const apiUrl = `${getApiHost()}/api/worker/task/demeter/items/${taskAcceptedInfoId}`;
    let url=`${apiUrl}?page=${page}&pageSize=${pageSize}`;

    if (sortField && sortOrder) { 
        url+=`&sortField=${sortField}&sortOrder=${sortOrder}`
    };
    
    return callFetch(API_GET,url,null,jwtToken);
}

export const createDemeterItemApi=(jwtToken:string,payload:any|null,taskAcceptedInfoId:string)=>{
    const apiUrl = `${getApiHost()}/api/worker/task/demeter/items/${taskAcceptedInfoId}`;
    return callFetch(API_POST,apiUrl,payload,jwtToken);
}

export const updateDemeterItemApi=(jwtToken:string,payload:any|null,id:string)=>{
    const apiUrl = `${getApiHost()}/api/worker/task/demeter/item/${id}/update`;
    return callFetch(API_PUT,apiUrl,payload,jwtToken);
}

export const moveDownDemeterItemApi=(jwtToken:string,id:string)=>{
    const apiUrl = `${getApiHost()}/api/worker/task/demeter/item/${id}/moveDown`;
    return callFetch(API_PUT,apiUrl,{},jwtToken);
}

export const moveUpDemeterItemApi=(jwtToken:string,id:string)=>{
    const apiUrl = `${getApiHost()}/api/worker/task/demeter/item/${id}/moveUp`;
    return callFetch(API_PUT,apiUrl,{},jwtToken);
}

export const deleteDemeterItemApi=(jwtToken:string,id:string)=>{
    const apiUrl = `${getApiHost()}/api/worker/task/demeter/item/${id}/delete`;
    return callFetch(API_DELETE,apiUrl,{},jwtToken);
}

export const getGorgonFormsApi=(jwt:string,isPROD:boolean)=>{
    let url=`${getApiHost()}/api/gorgon/forms`;
    if (isPROD){
        url=`${getApiHost()}/api/gorgon/prod/forms`;
    }
    return callFetch(API_GET,url,null,jwt);
}

export const getGorgonFormQuestionsApi=(jwt:string,gorgonFormId:string,isPROD:boolean)=>{
    let url=`${getApiHost()}/api/gorgon/formQuestions/${gorgonFormId}`;
    if (isPROD){
        url=`${getApiHost()}/api/gorgon/prod/formQuestions/${gorgonFormId}`;
    }
    return callFetch(API_GET,url,null,jwt);
}

export const getGorgonTaskApi=(jwt:string,taskAcceptedInfoId:string)=>{
    let url=`${getApiHost()}/api/gorgon/task/${taskAcceptedInfoId}`;
    return callFetch(API_GET,url,null,jwt);
}

export const getDemeterTaskApi=(jwt:string,taskAcceptedInfoId:string)=>{
    let url=`${getApiHost()}/api/demeter/task/${taskAcceptedInfoId}`;
    return callFetch(API_GET,url,null,jwt);
}

export const getDocTaskApi=(jwt:string,taskAcceptedInfoId:string)=>{
    let url=`${getApiHost()}/api/doc/task/${taskAcceptedInfoId}`;
    return callFetch(API_GET,url,null,jwt);
}

export const getHermesTaskApi=(jwt:string,taskAcceptedInfoId:string)=>{
    let url=`${getApiHost()}/api/hermes/task/${taskAcceptedInfoId}`;
    return callFetch(API_GET,url,null,jwt);
}

export const getHermesVendorsApi=(jwt:string)=>{
    let url=`${getApiHost()}/api/hermes/vendors`;
    return callFetch(API_GET,url,null,jwt);
}

export const getTaskApi=(jwt:string,workflowType:string,taskAcceptedInfoId:string)=>{
    let url=`${getApiHost()}/api/v2/generic/task/${workflowType}/${taskAcceptedInfoId}`;
    return callFetch(API_GET,url,null,jwt);
}

export const getVendorsApi=(jwt:string,workflowType:string)=>{
    let url=`${getApiHost()}/api/v2/generic/vendors/${workflowType}`;
    return callFetch(API_GET,url,null,jwt);
}

export const getLineItemsApi=(jwtToken:string,workflowType:string,page:number,pageSize:number,sortField:string,sortOrder:string,taskAcceptedInfoId:number)=>{
    const apiUrl = `${getApiHost()}/api/v2/generic/task/lineItems/${workflowType}/${taskAcceptedInfoId}`;
    let url=`${apiUrl}?page=${page}&pageSize=${pageSize}`;

    if (sortField && sortOrder) { 
        url+=`&sortField=${sortField}&sortOrder=${sortOrder}`
    };
    
    return callFetch(API_GET,url,null,jwtToken);
}

export const createLineItemApi=(jwtToken:string,workflowType:string,payload:any|null,taskAcceptedInfoId:number)=>{
    const apiUrl = `${getApiHost()}/api/v2/generic/task/lineItems/${workflowType}/${taskAcceptedInfoId}`;
    return callFetch(API_POST,apiUrl,payload,jwtToken);
}

export const updateLineItemApi=(jwtToken:string,workflowType:string,payload:any|null,id:number)=>{
    const apiUrl = `${getApiHost()}/api/v2/generic/task/lineItem/${workflowType}/${id}/update`;
    return callFetch(API_PUT,apiUrl,payload,jwtToken);
}

export const moveDownLineItemApi=(jwtToken:string,workflowType:string,id:number)=>{
    const apiUrl = `${getApiHost()}/api/v2/generic/task/lineItem/${workflowType}/${id}/moveDown`;
    return callFetch(API_PUT,apiUrl,{},jwtToken);
}

export const moveUpLineItemApi=(jwtToken:string,workflowType:string,id:number)=>{
    const apiUrl = `${getApiHost()}/api/v2/generic/task/lineItem/${workflowType}/${id}/moveUp`;
    return callFetch(API_PUT,apiUrl,{},jwtToken);
}

export const deleteLineItemApi=(jwtToken:string,workflowType:string,id:number)=>{
    const apiUrl = `${getApiHost()}/api/v2/generic/task/lineItem/${workflowType}/${id}/delete`;
    return callFetch(API_DELETE,apiUrl,{},jwtToken);
}


// WEBPACK FOOTER //
// ./src/apiUtils/api.js